import { ConfirmDialog } from '@/components/Dialog';
import { useTranslation } from 'react-i18next';

type ApplyFilterConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filterName: string;
};

export const ApplyFilterConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  filterName,
}: ApplyFilterConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('フィルターの適用')}
      messages={[
        t(
          '既に検索条件が設定されています。保存されたフィルター「{{filterName}}」を適用しますか？',
          {
            filterName,
          }
        ),
      ]}
      confirmText={t('適用する')}
    />
  );
};
